import { create } from "zustand";

const initialState = {
  openEmailModal: false,
  caseData: null,
  modalTitle: "Share Documents",
  templateName: null,
  lastEmailReciepient: [],
};

export const useEmailModal = create((set) => ({
  ...initialState,

  setOpenEmailModal: (value = {}) =>
    set({
      openEmailModal: true,
      ...value,
    }),
  setCaseData: (value) => set({ caseData: value }),
  setModalTitle: (value) => set({ modalTitle: value }),
  setTemplateName: (value) => set({ templateName: value }),
  setCloseEmailModal: () =>
    set((state) => ({
      ...initialState,
      lastEmailReciepient: state.lastEmailReciepient,
    })),
  setLastEmailReciepient: (value) => set({ lastEmailReciepient: value }),

  reset: () => set(initialState),
}));
